import NavigationCardWithDetails from "./NavigationCardWithDetails";
import NavigationCardWithDetailsAlt from "./NavigationCardWithDetailsAlt";
import NavigationCardWithDetailsLarge from "./NavigationCardWithDetailsLarge";
import { IProps } from "./types";

export type { IProps };
export { NavigationCardWithDetails, NavigationCardWithDetailsAlt, NavigationCardWithDetailsLarge };
export default NavigationCardWithDetails;
